import { facebook } from 'settings';

export const facebookInit = () => {
  'ngInject';

  window.fbAsyncInit = () => {
    window.FB.init({
      appId: facebook.appId,
      cookie: true,
      xfbml: true,
      version: 'v2.12',
    });
  };

  // prettier-ignore
  (function(d, s, id){
     var js, fjs = d.getElementsByTagName(s)[0];
     if (d.getElementById(id)) {return;}
     js = d.createElement(s); js.id = id;
     js.src = "https://connect.facebook.net/en_US/sdk.js";
     fjs.parentNode.insertBefore(js, fjs);
   }(document, 'script', 'facebook-jssdk'))
};



// WEBPACK FOOTER //
// ./src/utils/facebook.js